"use strict";
const EXACTA_ORDER_FULLFILLMENT_CENTER_ID = 'bd9a3170-383b-420d-94ce-5b0161723fde';
const VINDEN_ORDER_FULLFILLMENT_CENTER_ID = '90d702a1-eb2e-4fcd-b300-240a7808084c';
const VINDEN_ORDER_FULLFILLMENT_CENTER = {
    id: '90d702a1-eb2e-4fcd-b300-240a7808084c',
    name: 'Vinden - Kungsängen',
    description: '',
    active: true,
    owningSupplierOrganizationId: null,
    exciseNumber: 'SEP5569895468',
    taxWarehouseNumber: 'SEP0000036308',
    orderHeadCommentSupported: true,
    address: 'Mätarvägen 43',
    zipCode: '196 37',
    city: 'Kungsängen',
    deliveryName: "Flaivy Nation AB C/O Vinden AB'",
    deliveryAddress: 'Mätarvägen 33',
    deliveryZipCode: '196 37',
    deliveryCity: 'Kungsängen',
    orderFlowType: 'standard',
    dispatchEmail: 'hello@flaivy.com',
    reportRecipientEmail: 'hello@flaivy.com',
    packagingRules: '',
    handlingCost: null,
    deliveryBreakpointText: 'Möjliga leveransdatum justeras beroende på brytpunkt (kl 13), leveranstider, och om det är order i Stockholm eller övriga Sverige.',
    deliveryRules: null,
    deliveryRuleOverrides: null,
    transportCost: null,
    phone: '08-186688',
    isPossibleToPlaceOrderBelowOrderMinimum: false,
    shouldMergeOrders: true,
    minOrderValueByRegion: {
        region1: 2500,
        region2: 2500,
        region3: 3500,
        region4: 3500,
        region5: 3500,
        region6: 3500,
        region7: 3500,
        region8: 4000,
        region9: 3500,
        region10: 6000,
        region11: 9000,
    },
    minCollisOnOrderByRegion: null,
    kegCountsAsNCollis: 3,
    emailForInvoicing: null,
    emailForPurchaseOrder: null,
    checkoutMessage: 'Fakturan skickas av Flaivy Nation AB',
    metadata: {},
    createdAt: '2023-12-08T09:01:26.670Z',
    updatedAt: '2025-01-23T16:02:36.899Z',
    transportOptions: [],
    isCopack: true,
};
const EXACTA_ORDER_FULLFILLMENT_CENTER = {
    id: 'bd9a3170-383b-420d-94ce-5b0161723fde',
    name: 'Exacta - Karlskoga',
    description: "<p>exciseNumber: 'SEP5569895468',</p><p>taxWarehouseNumber: 'SEP0000035128',</p><p>name: 'Flaivy Nation AB / Exacta Logistics AB',</p><p>address: 'Verkstadsgatan 5',</p><p>zipCode: '69150',</p><p>city: 'Karlskoga',</p><p>deliveryName: 'Flaivy Nation AB / Exacta Logistics AB',</p><p>deliveryAddress: 'Verkstadsgatan 5',</p><p>deliveryZipCode: '69150',</p><p>deliveryCity: 'Karlskoga',</p>",
    active: true,
    owningSupplierOrganizationId: null,
    orderHeadCommentSupported: true,
    exciseNumber: 'SEP5569895468',
    taxWarehouseNumber: 'SEP0000035128',
    address: 'Verkstadsgatan 5',
    zipCode: '69150',
    city: 'Karlskoga',
    deliveryName: "Flaivy Nation AB / Exacta Logistics AB'",
    deliveryAddress: 'Verkstadsgatan 5',
    deliveryZipCode: '69150',
    deliveryCity: 'Karlskoga',
    orderFlowType: 'standard',
    dispatchEmail: 'dev@flaivy.com',
    reportRecipientEmail: 'dev@flaivy.com',
    packagingRules: '',
    handlingCost: null,
    deliveryBreakpointText: 'Möjliga leveransdatum justeras beroende på brytpunkt (kl 13), leveranstider, och om det är order i Stockholm eller övriga Sverige.',
    deliveryRules: null,
    deliveryRuleOverrides: null,
    transportCost: null,
    phone: '0',
    isPossibleToPlaceOrderBelowOrderMinimum: false,
    shouldMergeOrders: false,
    minOrderValueByRegion: null,
    minCollisOnOrderByRegion: null,
    kegCountsAsNCollis: 3,
    emailForInvoicing: null,
    emailForPurchaseOrder: null,
    checkoutMessage: null,
    metadata: {},
    createdAt: '2023-12-08T09:03:45.065Z',
    updatedAt: '2025-01-23T16:02:52.564Z',
    transportOptions: [],
    isCopack: true,
};
module.exports = {
    EXACTA_ORDER_FULLFILLMENT_CENTER_ID,
    VINDEN_ORDER_FULLFILLMENT_CENTER_ID,
    VINDEN_ORDER_FULLFILLMENT_CENTER,
    EXACTA_ORDER_FULLFILLMENT_CENTER,
};
